import React from 'react';

interface SkipLinkProps {
  href?: string;
  text?: string;
}

const SkipLink: React.FC<SkipLinkProps> = ({ href = '#app-container', text = 'Gå til sidens indhold' }) => {
  return (
    <a className="skip-link" href={href}>
      {text}
    </a>
  );
};

export default SkipLink;
